import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Default/Layout'
import './ServiceDetailPage.css'
import Image from '../components/Default/Image'
// Export Template for use in CMS preview
//        <div dangerouslySetInnerHTML={{ __html: props.body }}></div>

const ServiceDetailPageTemplate = props => (
  <div className="ServiceDetailPage">
    <Image className="top-yellow" src={props.rightArrow.fluid.src} />
    <Image className="top-blue" src={props.leftArrow.fluid.src} />
    <div className="container">
      <h2>{props.title}</h2>
      <div dangerouslySetInnerHTML={{ __html: props.body }} />
    </div>
    <div className="Contanct-area">
      <div className="container">
        <h3>Kontaktujte nás</h3>
        <a className="phone" href="tel:+420273139330">
          + 420 273 139 330
        </a>
        <div className="row align-items-start">
          <div className="col-lg-4 col-md-6 left">
            <a className="button">Náš tým</a>
          </div>
          <div className="col-lg-4 col-md-6">
            <a className="button">Kontaktní formulář</a>
          </div>
          <div className="col-lg-4 col-md-12 right">
            <a className="button">Naše pobočky</a>
          </div>
        </div>
      </div>
      <Image className="bottom-yellow" src={props.rightArrow.fluid.src} />
      <Image className="bottom-blue" src={props.leftArrow.fluid.src} />
    </div>
  </div>
)

const ServiceDetailPage = ({ data: { page, rightArrow, leftArrow } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <ServiceDetailPageTemplate
      {...page.frontmatter}
      body={page.html}
      rightArrow={rightArrow.childImageSharp}
      leftArrow={leftArrow.childImageSharp}
    />
  </Layout>
)

export default ServiceDetailPage

export const pageQuery = graphql`
  query ServiceDetailPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      ...Meta
      html
      frontmatter {
        title
        template
        subtitle
        featuredImage
        address
        phone
        email
        locations {
          mapLink
          lat
          lng
        }
      }
    }
    rightArrow: file(relativePath: { eq: "right-arrow.png" }) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
    leftArrow: file(relativePath: { eq: "left-arrow.png" }) {
      childImageSharp {
        fluid {
          src
        }
      }
    }
  }
`
